import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://vwwjda2e99.us-west-2.awsapprunner.com ';

let verifyRequest = null;
let verifyRequestKey = null;

/**
 * POST /verify-token?include=permissions, shared by ProtectedRoute and
 * PermissionsContext. On page load both ask at the same time, so they share one
 * in-flight request; the response also carries the caller's /my-permissions body
 * as `myPermissions` (absent when the backend could not resolve it).
 */
export function verifySession(token, idToken) {
  const requestKey = `${token}:${idToken || ''}`;
  if (!verifyRequest || verifyRequestKey !== requestKey) {
    const headers = { Authorization: `Bearer ${token}` };
    if (idToken) headers['x-id-token'] = idToken;

    verifyRequestKey = requestKey;
    const request = axios
      .post(`${API_BASE_URL}/verify-token?include=permissions`, {}, { headers })
      .finally(() => {
        if (verifyRequest === request) {
          verifyRequest = null;
          verifyRequestKey = null;
        }
      });
    verifyRequest = request;
  }
  return verifyRequest;
}
